exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-main[data-v-6beed8bc] {\n  position: relative;\n  height: 100%;\n}\n", ""]);

// exports
